import React, { useState } from 'react';
import { Award, Users, Clock, TrendingUp, Search, Eye, Edit, Copy } from 'lucide-react';
import useCertificationManagementStore from '@/stores/AdminStore/CertificationManagementStore';
import './CertificationList.css';

const CertificationList: React.FC = () => {
  const { certifications, certificationStats } = useCertificationManagementStore();

  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');

  const stats = [
    { label: 'Total Certifications', value: certificationStats?.totalCertifications || '0', icon: <Award size={20} />, color: '#3B82F6' },
    { label: 'Certified Users', value: certificationStats?.certifiedUsers || '0', icon: <Users size={20} />, color: '#10B981' },
    { label: 'Expiring Soon', value: certificationStats?.expiringSoon || '0', icon: <Clock size={20} />, color: '#F59E0B' },
    { label: 'Completion Rate', value: certificationStats?.completionRate || '0%', icon: <TrendingUp size={20} />, color: '#8B5CF6' },
  ];

  return (
    <div className="admin-certifi-list">
      <div className="admin-certifi-list-header">
        <div className="admin-certifi-stats-grid">
          {stats.map((stat, index) => (
            <div key={index} className="admin-certifi-stat-card">
              <div className="admin-certifi-stat-icon" style={{ backgroundColor: `${stat.color}20`, color: stat.color }}>
                {stat.icon}
              </div>
              <div className="admin-certifi-stat-info">
                <p className="admin-certifi-stat-label">{stat.label}</p>
                <h3 className="admin-certifi-stat-value">{stat.value}</h3>
              </div>
            </div>
          ))}
        </div>

        <div className="admin-certifi-list-controls">
          <div className="admin-certifi-search-box">
            <Search size={18} />
            <input
              type="text"
              placeholder="Search Certificate"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <select
            className="admin-certifi-status-filter"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="all">All Status</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>
      </div>

      <div className="admin-certifi-certifications-grid">
        {certifications?.map((cert) => (
          <div key={cert.id} className="admin-certifi-cert-card">
            <div className="admin-certifi-cert-card-header">
              <div className="admin-certifi-cert-icon">
                <Award size={24} />
              </div>
              <span className="admin-certifi-cert-status admin-certifi-cert-status-active">active</span>
            </div>

            <h3 className="admin-certifi-cert-name">{cert.name}</h3>
            <p className="admin-certifi-cert-description">{cert.description}</p>

            <div className="admin-certifi-cert-details">
              <div className="admin-certifi-cert-detail-item">
                <span className="admin-certifi-detail-label">Validity:</span>
                <span className="admin-certifi-detail-value">{cert.validity}</span>
              </div>
              <div className="admin-certifi-cert-detail-item">
                <span className="admin-certifi-detail-label">Requirements:</span>
                <span className="admin-certifi-detail-value">{cert.requirements} items</span>
              </div>
              <div className="admin-certifi-cert-detail-item">
                <span className="admin-certifi-detail-label">Certified Users:</span>
                <span className="admin-certifi-detail-value">{cert.certifiedUsers}</span>
              </div>
            </div>

            <div className="admin-certifi-cert-actions">
              <button className="admin-certifi-action-btn admin-certifi-action-btn-copy">
                <Copy size={16} />
              </button>
              <button className="admin-certifi-action-btn admin-certifi-action-btn-view">
                <Eye size={16} />
                View
              </button>
              <button className="admin-certifi-action-btn admin-certifi-action-btn-edit">
                <Edit size={16} />
                Edit
              </button>
            </div>

            <p className="admin-certifi-cert-created">Created {cert.created}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CertificationList;
